export default "__VITE_ASSET__cf239ca0__"